<template>
    <div class="login">
        <div class="container">
            <div class="row">
                <div class="col-md-2"></div>
                <div class="col-md-8" align-v="center">
                    <div class="card">
                        <div class="card-head">
                            <div class="row">
                                <div class="col-md-6 col-12 primes text-white text-center">
                                    <div style="margin-top:60%" >
                                    <div >
                                       <h4 class="text-white"> <b>Shipserv Ltd Triq Patri Tedeo Schembri ZABBAR ZBR2691 MALTA</b> </h4> 
                                    </div>
                                    <div>
                                      <h5 class="text-white">Tax Number: MT 2184 7134</h5> 
                                    </div>
                                    </div>
                                    <!-- <img src="../assets/img/oneshot.png" width="100%" class="logo" alt=""> -->
                                </div>
                                <div class="col-md-6 col-12 text-center px-5">
                                    <h2 class="heading">Login</h2>
                                    <form class="mt-3">
                                        <input type="email" v-model="login.email" placeholder="Email" class="form-control">
                                        <input type="password" v-model="login.password" placeholder="Password" class="form-control mt-3">
                                        <!-- <button class="form-control btn btn-primary mt-3">Login</button> -->
                                        <b-button variant="primary" class="mt-3" block @click="authlogin">Login</b-button>
                                        <div><sub>Dont have an account <router-link to="/register">Create One</router-link> </sub></div>
                                        <div><sub>Reset your password <router-link to="/reset-password">Click Here</router-link> </sub></div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Login",
    methods: {

        authlogin() {
            // this.$router.push({path: '/dashboard'})
            // this.$store.commit("setauthedUser",{username:'abcc'})
            this.$store.dispatch("authenticatelogin",this.login)

        },

    },
    data(){
        return {
            
            login:{
            email:'',//dawoodahmed696@gmail.com//info@lanemo.co
            password:''//dawoodahmed//sslmalta//dawoodahmed
            }
        }
    }
}
</script>

<style scoped>

.login {
        /* background: #d7dfe1; */
        min-height: 100vh;
        padding-top: 40px;
    }
    .primes {
        background: #5580fe;
        height: 710px !important;
    }
    .logo {
        margin-top: 70%;
    }
    
    p {
        font-size: 14px;
        margin-top: 10px;
    }
    .log:hover {
        cursor: pointer;
    }
    h2 {
        margin-top: 70%;
    }
    @media screen and (max-width: 567px) {
        .login {
            padding-top: 0px;
        }
        h2 {
            margin-top: 10%;
        }
    }
</style>